






























































































































import Vue from 'vue';
import JoinWrapper from './JoinWrapper.vue';
import ChooseSubscriptionButton from './ChooseSubscriptionButton.vue';
import SpecialAccessInput from './SpecialAccessInput.vue';
import BillingService from '~/services/BillingService';
import StripePaymentPng from '~/assets/img/stripe-payment.png';
import { PERKS_COMMON, PERKS_EXTENDED, TESTIMONIALS } from './consts';
import CourseraService from '~/services/CourseraService';
import URLS from '~/URLS';

type SubscriptionType = 'month' | 'semester' | 'special';

interface CourseraItem {
    id: string;
    price: number;
}

interface CourseraItems {
    month: CourseraItem | null;
    semester: CourseraItem | null;
}

export default Vue.extend({
    name: 'ChooseSubscription',
    components: {
        JoinWrapper,
        ChooseSubscriptionButton,
        SpecialAccessInput,
    },
    data() {
        return {
            loading: true,
            error: false,
            items: {
                month: null,
                semester: null,
            } as CourseraItems,

            accessCode: '',
            courseraRedirect: null as string | null,
            specialAccess: false,

            perks: {
                month1: PERKS_COMMON,
                month6: PERKS_EXTENDED,
            },
            testimonials: [], // TESTIMONIALS,
            stripePaymentPng: StripePaymentPng,
        };
    },
    computed: {
        prices(): { month: number; semester: number } {
            return {
                month: !this.items.month ? 49 : Math.round(this.items.month.price / 100),
                semester: !this.items.semester
                    ? 43
                    : Math.round(this.items.semester.price / 100 / 6),
            };
        },
    },
    methods: {
        getAuthorImage(image: string | null) {
            return null;
        },
        openHowTo(purchase: boolean) {
            this.$router.push({
                path: URLS.courseraHowTo,
                query: {
                    purchase: String(purchase),
                },
            });
        },
        initCardsScrollPos() {
            const id = window.setInterval(() => {
                const cards = document.querySelector('#choose-subscription-cards');
                if (!cards) return;

                const vw = (window.innerWidth / 100) * 20;
                cards.scrollTo({
                    left: (cards.scrollWidth - vw) / 3,
                    behavior: 'auto',
                });

                window.clearInterval(id);
            }, 50);
        },

        handleCheckout(type: SubscriptionType) {
            if (type === 'special') {
                this.useAccessCode();
                return;
            }

            const item = this.items[type];
            if (!item || !item.id) return;

            this.createCheckout(item.id, type);
        },
        async createCheckout(priceId: string, type: Exclude<SubscriptionType, 'special'>) {
            const returnUrl = window.location.origin + URLS.courseraChooseSubscription;
            const data = await BillingService.createStripeCheckoutSession({
                items: [
                    {
                        priceId,
                        quantity: 1,
                    },
                ],
                mode: type === 'month' ? 'subscription' : 'payment',
                returnUrl,
            });

            BillingService.redirectToStripeSession({
                sessionId: data.sessionId,
            });
        },
        async useAccessCode() {
            if (!this.accessCode) return;

            const code = this.accessCode.toUpperCase();
            CourseraService.useAccessCode(code).then(acc => acc.granted && this.openHowTo(false));
        },
        fetchProducts() {
            BillingService.getProductsByTags({
                category: 'coursera',
            })
                .then(prods => {
                    this.items = prods.reduce<CourseraItems>((acc, cur) => {
                        if (!cur.prices.length || !cur.tags.hasOwnProperty('type')) return acc;

                        const price = cur.prices.find(price => price.active);
                        if (!price) return acc;

                        const item: CourseraItem = {
                            id: price.id,
                            price: price.price,
                        };

                        return {
                            ...acc,
                            [cur.tags.type]: item,
                        };
                    }, this.items);
                })
                .catch(reason => {
                    console.error(reason);
                    this.error = true;
                })
                .finally(() => (this.loading = false));
        },
    },
    mounted() {
        CourseraService.checkHasAccess().then(acc => {
            if (acc.access) this.openHowTo(false);
            else this.fetchProducts();
        });

        const params = new URLSearchParams(window.location.search);
        if (params.get('success') === 'true') this.openHowTo(true);

        this.initCardsScrollPos();
    },
});
